import Model, { attr } from '@ember-data/model';

import type { RecordData } from 'webapp-types';

export default class ReportSlideFragmentRecord extends Model {
	@attr('number') type!: number;
	@attr('number') reportSlideId!: number;
	@attr('number') order!: number;
	@attr('number') referenceId!: number; // id of board / block
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	value!: RecordData.ReportSlideFragment.Value;

	@attr('string') changeText!: string | null; // used to synch report title with header text

	// seperate settings that will be serialized to 'settings' field
	@attr('number') width!: number;
	@attr('number', { defaultValue: 100 }) height!: number;

	// only for internal webapp use
	@attr('boolean', { defaultValue: false }) declare isNewlyCreated: boolean;
}
